import { DEVICES } from '../../../../device';
import { getDeviceType } from '../../../helpers/browser';

export default (device = getDeviceType()) => [DEVICES.PHONE, DEVICES.TABLET].includes(device);
